// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1477":"4c576641","7996":"a71f4980"}[chunkId] + ".chunk.css";
};